export default __webpack_public_path__ + "static/media/logo4.caeb4e9f.webp";